import { copyToClipboard } from './copyToClipboard.js';

function webShare(text, url) {
    if (navigator.share) {
        navigator
            .share({
            text,
            url
        })
            .then(() => {
            console.log("Thanks for sharing!");
        })
            .catch(console.error);
    }
    else {
        copyToClipboard(`${text}\n${url}`);
    }
}

export { webShare };
//# sourceMappingURL=web-share.js.map
